import React from "react";
import Home from "../components/Home/Home";

function HomePage() {
  return <Home />;
}

export default HomePage;
